import { _ as i } from "./atoms-v21253.js";
import { h as n } from "./atoms-v21254.js";
var e = i, o = n;
function t(a, r) {
  return e(a, r, function(c, s) {
    return o(a, s);
  });
}
var f = t;
export {
  f as _
};
